import { render, staticRenderFns } from "./ContabilitaFatturazioneView.vue?vue&type=template&id=128318bb"
import script from "./ContabilitaFatturazioneView.vue?vue&type=script&lang=js"
export * from "./ContabilitaFatturazioneView.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaFatturazioneView.vue?vue&type=style&index=0&id=128318bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports